/* VENDOR_CATS */
export const GET_VENDOR_CATS = "GET_VENDOR_CATS"
export const GET_VENDOR_CATS_SUCCESS = "GET_VENDOR_CATS_SUCCESS"
export const GET_VENDOR_CATS_FAIL = "GET_VENDOR_CATS_FAIL"

/* VENDOR_CATS PROFILE */
export const GET_VENDOR_CAT_PROFILE = "GET_VENDOR_CAT_PROFILE"
export const GET_VENDOR_CAT_PROFILE_SUCCESS = "GET_VENDOR_CAT_PROFILE_SUCCESS"
export const GET_VENDOR_CAT_PROFILE_FAIL = "GET_VENDOR_CAT_PROFILE_FAIL"

/**
 * add VENDOR_CAT
 */
 export const ADD_NEW_VENDOR_CAT = "ADD_NEW_VENDOR_CAT"
 export const ADD_VENDOR_CAT_SUCCESS = "ADD_VENDOR_CAT_SUCCESS"
 export const ADD_VENDOR_CAT_FAIL = "ADD_VENDOR_CAT_FAIL"

 /**
 * Edit VENDOR_CAT
 */
export const UPDATE_VENDOR_CAT = "UPDATE_VENDOR_CAT"
export const UPDATE_VENDOR_CAT_SUCCESS = "UPDATE_VENDOR_CAT_SUCCESS"
export const UPDATE_VENDOR_CAT_FAIL = "UPDATE_VENDOR_CAT_FAIL"

/**
 * Delete VENDOR_CAT
 */
export const DELETE_VENDOR_CAT = "DELETE_VENDOR_CAT"
export const DELETE_VENDOR_CAT_SUCCESS = "DELETE_VENDOR_CAT_SUCCESS"
export const DELETE_VENDOR_CAT_FAIL = "DELETE_VENDOR_CAT_FAIL"


